import ZoneSelectorControlBase from './ZoneSelectorControlBase';
import dom from '../../../../utils/dom';


class ZoneSelectList extends ZoneSelectorControlBase {
  /**
   * @param {HTMLSelectElement} select
   */
  constructor(select) {
    super();

    this.select = select;

    this.onSelectChange = this.onSelectChange.bind(this);

    this.items = Array.from(this.select.options)
      .filter(option => option.value)
      .map(option => ({
        option,
        zoneId: option.value,
        zoneGroupId: option.getAttribute('data-tn-zone-group-id'),
        isSelected: false,
        isAvailable: !option.disabled,
      }));

    this.select.addEventListener('change', this.onSelectChange);
  }

  onSelectChange() {
    const zoneId = this.select.value;

    this.notifyZoneChange(zoneId);
  }

  selectZone(zoneId) {
    const item = this.getItem(zoneId);

    if (item) {
      this.deselectZoneGroupItems(item.zoneGroupId);

      this.select.value = zoneId;

      item.isSelected = true;
    } else {
      this.select.selectedIndex = 0;
    }
  }

  destroy() {
    this.removeAllListeners();
    this.select.removeEventListener('change', this.onSelectChange);
  }

  selectZoneGroup(zoneGroupId) {
    this.items.forEach((item) => {
      if (item.zoneGroupId === zoneGroupId) {
        this.select.append(item.option);
      } else {
        if (item.option.parentElement) {
          dom.remove(item.option);
        }
      }
    });
  }
}


export default ZoneSelectList;



// WEBPACK FOOTER //
// ./src/events/detail/zoneSelector/controls/ZoneSelectList.js